// ==============================|| OVERRIDES - LOADING BUTTON ||============================== //

export default function LoadingButton(theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          '&.MuiLoadingButton-loading': {
            opacity: 0.6,
            textShadow: 'none',
          },
        },
        sizeLarge: {
          width: theme.spacing(6),
          height: theme.spacing(6),
          fontSize: '1.25rem',
        },
        sizeMedium: {
          width: theme.spacing(4.5),
          height: theme.spacing(4.5),
          fontSize: '1rem',
        },
        sizeSmall: {
          width: theme.spacing(3.75),
          height: theme.spacing(3.75),
          fontSize: '0.75rem',
        },
        loadingIndicator: {
          color: theme.palette.text.primary,
        },
      },
    },
  }
}
